import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import "./TutorVideo.scss";
import Header_component from "../../../../structure_components/desktop_screens/header_component/header_component";
import Footer_component from "../../../../structure_components/desktop_screens/footer_component/Footer_component";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";
import images from "../../../../../../utilities/images/images";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfView = () => {
  const location = useLocation();
  const history = useHistory();
  const videoData = location.state?.videoData;

  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(null);
  const [scale, setScale] = useState(1.5);
  const [pdfError, setPdfError] = useState(null);

  useEffect(() => {
    console.log("PDF URL:", videoData?.notes?.url);
  }, [videoData]);

  useEffect(() => {
    if (!videoData) {
      history.push("/history");
    }
  }, [videoData, history]);

  // Handle back navigation
  const handleBackClick = () => {
    history.goBack();
  };

  if (!videoData) {
    return null;
  }

  return (
    <>
      <Header_component />
      <div className="video-player-page">
        <div className="video-player-content">
          <div>
            <div style={{ marginTop: "70px" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={images.leftArrow}
                  alt="Back"
                  style={{ width: "38px", height: "38px", cursor: "pointer" }}
                  onClick={handleBackClick}
                />
                <h4>Class Notes</h4>
              </div>
              <div id="pdf-div" className="notes_inner_wrapper">
                <div className="pdf-container">
                  {pdfError ? (
                    <p style={{ color: "red" }}>
                      Error loading PDF: {pdfError.message}
                    </p>
                  ) : videoData.notes?.url ? (
                    <Document
                      file={videoData.notes.url}
                      onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                      onLoadError={(error) => {
                        console.error("PDF loading error:", error);
                        setPdfError(error);
                      }}
                      onContextMenu={(e) => e.preventDefault()}
                      renderMode="canvas"
                    >
                      {numPages ? (
                        Array.from(new Array(numPages), (el, index) => (
                          <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            width={pageWidth}
                            scale={scale}
                          />
                        ))
                      ) : (
                        <p>Loading PDF...</p>
                      )}
                    </Document>
                  ) : (
                    <p>No PDF available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer_component />
    </>
  );
};

export default PdfView;
